import React from 'react'
import { useState, useEffect } from 'react';

// mui material
import {
    Box,
    Button,
    InputAdornment,
    OutlinedInput,
    IconButton,
    Tooltip
} from '@mui/material';
import Grid from '@mui/system/Unstable_Grid/Grid';
import AddIcon from '@mui/icons-material/Add';
import { IconSearch } from '@tabler/icons';
import FilterListIcon from '@mui/icons-material/FilterListTwoTone';

// project import
import { gridSpacing, USER_TYPE } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import PaginationRows from 'ui-component/extended/PaginationRows';
import { UserList } from './UserList';
import useApi from 'hooks/useApi';
import UserService from 'services/UserService';
import VenueService from 'services/VenueService';
import Filter from './UserFilter';
import { CreateUser } from './CreateUser';

const UserTab = ({ userType }) => {

    const [open, setOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState('')
    const [total, setTotal] = useState(1);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [limit, setLimit] = useState(10);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [filterObj, setFilterObj] = useState({
        start_date: '',
        end_date: '',
        user_type: [userType],
        uuid_venue: []
    });
    const [venueArray, setVenueArray] = useState([]);

    const changeSearch = (e) => {
        setSearchText(e.target.value);
        setPage(1);
    };

    const handleUserCloseDialog = () => {
        setOpen(false);
        setSelectedUser(null);
    };

    const handleUserOpenDialog = (selectedUserUuid) => {
        if (selectedUserUuid) {
            getUserByUuid.execute(selectedUserUuid);
        } else {
            setOpen(true);
        }
    };

    const handleCloseDialog = () => {
        setOpenFilter(false);
    };

    const handleClickOpenDialog = () => {
        setOpenFilter(true);
    };

    const getUserListHandler = (response) => {
        const data = response.data;
        setRows(data.rows);
        setTotal(data.filtered);
    };

    const getUserHandler = (response) => {
        setSelectedUser(response.data);
        setOpen(true);
    };

    const venueListHandler = (response) => {
        setVenueArray(response.data);
    };

    const userListApi = useApi(UserService.getUserList, getUserListHandler);
    const getUserByUuid = useApi(UserService.getUserByUuid, getUserHandler);
    const getVenueListApi = useApi(VenueService.getVenueDropdownList, venueListHandler);

    useEffect(() => {
        userListApi.execute({
            limit,
            skip: (page * limit) - limit,
            searchValue: searchText.trim(),
            filter: filterObj
        });
    }, [searchText, page, limit, reload, filterObj]);

    useEffect(() => {
        if (userType === USER_TYPE[0].value) {
            getVenueListApi.execute();
        }
    }, []);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard title={
                <Grid container sx={{ alignItems: 'center', justifyContent: "space-between" }} spacing={gridSpacing}>
                    <Grid item xs={12} md={3}>
                        <Box>
                            <OutlinedInput
                                id="input-search-list-style1"
                                placeholder="Search name, email, phone, usercode ...."
                                fullWidth
                                sx={{ maxWidth: '300px' }}
                                value={searchText}
                                onChange={changeSearch}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <IconSearch stroke={1.5} size="16px" />
                                    </InputAdornment>
                                }
                                size="small"
                            />
                        </Box>
                    </Grid>
                    <Grid xs={12} md={5}>
                        <Grid container justifyContent={{ xs: 'flex-start', md: 'flex-end' }} alignItems='center' spacing={gridSpacing}>
                            <Grid item >
                                <Tooltip title="Filter">
                                    <IconButton
                                        size="large"
                                        onClick={handleClickOpenDialog}
                                        sx={{ boxShadow: 'none', ml: 1, width: 32, height: 32, minHeight: 32 }}
                                    >
                                        <FilterListIcon />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                            <Grid item>
                                <Button startIcon={<AddIcon />} variant='contained' color='secondary' onClick={() => handleUserOpenDialog()}>
                                    Create {userType === USER_TYPE[0].value ? 'Manager' : 'Customer'}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
                content={false}
            >
                <UserList
                    rows={rows}
                    setReload={setReload}
                    page={page}
                    limit={limit}
                    open={open}
                    handleUserOpenDialog={handleUserOpenDialog}
                    userType={userType}
                />
                <PaginationRows
                    total={total}
                    page={page}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    limits={[10, 15, 20]}
                />
            </MainCard>
            <CreateUser
                open={open}
                handleClose={handleUserCloseDialog}
                selectedUser={selectedUser}
                userType={userType}
                setReload={setReload}
                venueArray={venueArray}
            />
            <Filter
                open={openFilter}
                handleCloseDialog={handleCloseDialog}
                filterObj={filterObj}
                setFilterObj={setFilterObj}
                setPage={setPage}
                userType={userType}
                venueArray={venueArray}
            />
        </Box>
    );
};

export default UserTab;
